<ul
  class="document-items-list"
  [ngClass]="{ reordering: reorderingMode }"
  [sortablejs]="documentItemCalculatedResults"
  [sortablejsOptions]="sortableJsOptions"
>
  <li
    *ngFor="
      let documentItemResult of documentItemCalculatedResults;
      trackBy: trackByFn
    "
    class="document-item-list-item-wrapper"
    [ngClass]="{ 'edit-mode': editMode }"
  >
    <app-document-items-list-item
      [documentItem]="documentItemResult.item"
      [document]="document"
      [documentItemCalculationResult]="documentItemResult.calculationResult"
      [documentDataBuilder]="documentDataBuilder"
      [documentTaxes]="documentTaxes"
      [documentWithholdingTax]="documentWithholdingTax"
      [documentSettings]="documentSettings"
      [companySettings]="companySettings"
      [editingDocumentItemId]="editingDocumentItemId"
      [enableDiscount]="enableDiscount"
      [trackingObject]="trackingObject"
      [trackingScreenName]="trackingScreenName"
      [sortableHandle]="sortableHandle"
      (onDeleteDocumentItem)="onDeleteDocumentItem.emit($event)"
      (onSaveDocumentItem)="onSaveDocumentItem.emit($event)"
      (onSaveItemToList)="onSaveItemToList.emit($event)"
      (onDocumentItemEditMode)="onDocumentItemEditMode($event)"
    >
    </app-document-items-list-item>
  </li>
</ul>
